import React from "react"
import InsuranceDetails from "components/insurance-details"
import { InsuranceDetailsProvider } from "components/insurance-details/context/useInsuranceDetails"
import { CenteredLayout } from "components/views/atoms/Layouts"
// eslint-disable-next-line import/no-restricted-paths
import { PageHeader } from "components/views/molecules/PageHeader"
import { ReimbursementStatusProvider } from "components/context/reimbursement/ReimbursementStatusContext"
import { Container } from "@carrotfertility/carotene"
// eslint-disable-next-line import/no-restricted-paths
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import { DeductibleProvider } from "components/context/user/DeductibleContext"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { Redirect } from "react-router-dom"
import EmployeeOnlySpaceContainer from "components/employee-only-containers/EmployeeOnlySpaceContainer"
import { useIntl } from "react-intl"

const InsuranceDetailsPage = (): JSX.Element => {
  const { shouldDisplayInsuranceDetails } = useBenefitEnrollment()

  const intl = useIntl()
  const InsuranceHeader = (): JSX.Element => (
    <PageHeader icon="icn-insurance" title={intl.formatMessage({ defaultMessage: "Insurance details" })} />
  )

  if (!shouldDisplayInsuranceDetails) {
    return <Redirect to="/" />
  }

  return (
    <MasterLayout header={<InsuranceHeader />}>
      <EmployeeOnlySpaceContainer>
        <CenteredLayout>
          <DeductibleProvider>
            <InsuranceDetailsProvider>
              <ReimbursementStatusProvider>
                <Container sx={{ paddingBottom: "64px" }}>
                  <InsuranceDetails />
                </Container>
              </ReimbursementStatusProvider>
            </InsuranceDetailsProvider>
          </DeductibleProvider>
        </CenteredLayout>
      </EmployeeOnlySpaceContainer>
    </MasterLayout>
  )
}

export default InsuranceDetailsPage
